import {
  IntegrationResponse,
  GoogleAdsCustomer,
  GoogleAdsCustomersApiResponse,
  GoogleAdsConnectedCustomersResponse,
  MetaAdsAccount,
  MetaAdsAccountsResponse,
} from "@/types/integrations";

// Dados fictícios para as páginas de Integração na conta Preview: sempre
// aparecem já conectadas, então os fluxos de OAuth de conectar nunca são
// acionados nessa conta.

export const mockIntegrationStatus = (): IntegrationResponse => ({
  data: {
    google: { isConnected: true, customersSelected: true },
    meta: { isConnected: true, accountsSelected: true },
  },
});

const MOCK_GOOGLE_ADS_CUSTOMERS: GoogleAdsCustomer[] = [
  { id: "1234567890", name: "Loja Demo - Conta Principal" },
  { id: "2345678901", name: "Loja Demo - Campanhas Sazonais" },
];

export const mockGoogleAdsConnectedCustomers =
  (): GoogleAdsConnectedCustomersResponse => MOCK_GOOGLE_ADS_CUSTOMERS;

// Respeita `page` (mesmo contrato da API real: página > 1 retorna vazio)
// para nunca virar um loop infinito em código que pagina até vir vazio.
export const mockGoogleAdsCustomers = (
  page: number = 1,
): GoogleAdsCustomersApiResponse => ({
  data: page > 1 ? [] : MOCK_GOOGLE_ADS_CUSTOMERS,
  pagination: { page, total: 1 },
});

const MOCK_META_ADS_ACCOUNTS: MetaAdsAccount[] = [
  { id: "9876543210", name: "Loja Demo - Conta de Anúncios" },
];

export const mockMetaAdsConnectedAccounts = (): MetaAdsAccountsResponse => ({
  accounts: MOCK_META_ADS_ACCOUNTS,
});

export const mockMetaAdsAccounts = (): MetaAdsAccountsResponse => ({
  accounts: MOCK_META_ADS_ACCOUNTS,
});

// No-op: usado para bloquear ações de escrita (desconectar/salvar) na conta
// Preview, sem chamar a API real.
export const mockVoid = (): void => undefined;
